import type { StoreOptions, Store } from 'vuex'
import { Data } from '@didi/mfe-global-utils'

if (!Object.fromEntries) {
  Object.fromEntries = require('object.fromentries')
}

let store: Store<any> | null = null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerStore<S = any>(appStore: Store<S>) {
  store = appStore
  window.$store = appStore
}

export function useStore<T = any>() {
  return store as Store<T>
}

export const defineStore = <T = any>(
  store: StoreOptions<T>
) => {
  return {
    ...store,
  }
}

export type IStoreState<S = any> = Exclude<
  S,
  // eslint-disable-next-line @typescript-eslint/ban-types
  undefined | Function
>

export const useState = <T = Record<string, any>>(
  module: string,
  states: string[]
) => {
  return Object.fromEntries(
    states.map((s) => [s, store?.state[module][s]])
  ) as T
}

export const useActions = (
  module: string,
  actions: string[]
) => {
  return Object.fromEntries(
    actions.map((a) => [
      a,
      (payload?: any) =>
        store?.dispatch(`${module}/${a}`, payload),
    ])
  )
}

export const useMutations = (
  module: string,
  mutations: string[]
) => {
  return Object.fromEntries(
    mutations.map((m) => [
      m,
      (payload: any) => store?.commit(`${module}/${m}`, payload),
    ])
  )
}

export const useGetters = <T = Record<string, any>>(
  module: string,
  getters: string[]
) => {
  return Object.fromEntries(
    getters.map((g) => [g, store?.getters[`${module}/${g}`]])
  ) as T
}

/**
 * 生成 defineProperties 的属性描述符，并从 vuex state 里面获取数据
 * @param name
 */
export const createPropertiesByState = (name: string) => {
  return {
    enumerable: true,
    configurable: true,
    get() {
      return Data.safeGetValue(window?.$store?.state, name)
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set() {},
  }
}
